import { CheckIcon, XMarkIcon } from "@heroicons/react/24/solid";
import { cn } from "@utils";

// The "this suggestion is settled" marker shown where the accept button was, once a suggestion is
// accepted (done) or rejected. Shared by every suggestion card so the treatment stays identical.
//
// A soft tinted disc with a ring rather than a heavy solid fill — it reads as a calm, finished state
// that sits quietly beside the card instead of shouting, matching the app's badge language.
export default function SuggestionStatusBadge({ done }) {
  const Icon = done ? CheckIcon : XMarkIcon;
  return (
    <span
      aria-label={done ? "Done" : "Rejected"}
      className="animate-tickIn flex min-w-[2.25rem] shrink-0 items-center justify-center"
    >
      <span
        className={cn(
          "flex size-7 items-center justify-center rounded-full ring-1 ring-inset",
          done
            ? "bg-emerald-50 text-emerald-600 ring-emerald-600/20"
            : "bg-zinc-100 text-zinc-400 ring-zinc-500/15",
        )}
      >
        <Icon aria-hidden="true" className="size-4" strokeWidth={2} />
      </span>
    </span>
  );
}
